import { components } from 'react-select';

import { IndicatorsContainerProps } from './IndicatorContainer.types';
import { useStyles } from './IndicatorsContainer.styles';
import { SelectOptionProps } from '../../SelectOption.types';
import { RenderWhen } from '../../../../../RenderWhen';

export const IndicatorsContainer = ({ children, ...rest }: IndicatorsContainerProps) => {
  const styles = useStyles({
    isDisabled: rest.selectProps.isDisabled,
  });

  const selectProps = rest.selectProps as unknown as SelectOptionProps;
  const endContent = selectProps.endContent;

  return (
    <components.IndicatorsContainer css={styles.root} {...rest}>
      <RenderWhen condition={Boolean(endContent)}>{endContent}</RenderWhen>
      {children}
    </components.IndicatorsContainer>
  );
};
